export const SERVER_ERROR = {
    message: 'Some server error occurred'
}